import { useState, useEffect } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { useNavigate, useLocation } from "react-router-dom";

const LOGIN_URL = 'api/User/resources';

const Contacts = () => {
    const [contacts, setContacts] = useState();
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        var isMounted = true;
        const controller = new AbortController();

        const getContacts = async () => {
            try {
                const res = await axiosPrivate.get(LOGIN_URL, {
                    signal: controller.signal
                });
                isMounted && setContacts(res.data)
            } catch (err) {
                console.log(err);
                navigate('/login', { state: { from: location }, replace: true });
            }
        }
        
        getContacts();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [])

    return (
        <article>
            <h2>
                List of contacts    
            </h2>
            { contacts?.length ? (
                <ul>
                    { contacts }
                </ul>
            ) : 
            <p>
                No contacts
            </p> 
            }
        </article>
    );
};

export default Contacts;